import { render, staticRenderFns } from "./scrUserDetai.vue?vue&type=template&id=2a009eae&scoped=true"
import script from "./scrUserDetai.vue?vue&type=script&lang=js"
export * from "./scrUserDetai.vue?vue&type=script&lang=js"
import style0 from "./scrUserDetai.vue?vue&type=style&index=0&id=2a009eae&prod&lang=scss&scoped=true"
import style1 from "./scrUserDetai.vue?vue&type=style&index=1&id=2a009eae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a009eae",
  null
  
)

export default component.exports